import React, { useState, useEffect } from "react";
import { useAtom } from "jotai";
import { motion } from "framer-motion";
import { themeAtom, isDebouncingAtom } from "../../../../../-Atoms";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { v4 as uuidv4 } from "uuid";
import { db, doc, updateDoc } from "../../../../../firebaseConfig";

import VideoEditingItemV2 from "./VideoEditingItemV2";

const VideoEditingBreakdownV2 = ({
  videoEditingBreakdown,
  setVideoEditingBreakdown,
  jobData,
  staffData,
  updateFS,
  findStaff,
}) => {
  const [theme] = useAtom(themeAtom);
  const [isDebouncing] = useAtom(isDebouncingAtom);
  const [hoursTotal, setHoursTotal] = useState(0.0);
  const [showRemoveVideoEditingItem, setShowRemoveVideoEditingItem] = useState(false);

  useEffect(() => {
    let total = 0.0;
    videoEditingBreakdown &&
      videoEditingBreakdown.forEach((veb) => {
        if (veb.hours) {
          total = parseFloat(total) + parseFloat(veb.hours);
        }
      });
    setHoursTotal(total.toFixed(1));
  }, [videoEditingBreakdown]);

  const addVideoEditingItem = () => {
    const currentBreakdown = Array.isArray(videoEditingBreakdown) ? videoEditingBreakdown : [];
    const newitemObj = {
      id: uuidv4(),
      date: "",
      hours: "",
      staff: "",
      notes: "",
    };
    const updatedBreakdown = [...currentBreakdown, newitemObj];
    setVideoEditingBreakdown(updatedBreakdown);
    updateDoc(doc(db, "JobData", jobData.id), { videoEditingBreakdown: updatedBreakdown })
      .catch((e) => console.log(e));
  };

  const toggleShowVideoEditingItem = () => {
    setShowRemoveVideoEditingItem(true);
    setTimeout(() => {
      setShowRemoveVideoEditingItem(false);
    }, 6000);
  };


  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
        ease: [0.25, 0.1, 0.25, 1.0],
      },
    },
  };

  return (
    <motion.div variants={itemVariants}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          borderRadius: "10px",
          backgroundColor:
            theme === "dark" ? "rgba(35,35,35,0.7)" : "rgba(235,235,235,0.9)",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          boxShadow:
            theme === "dark"
              ? "0 2px 10px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.1)"
              : "0 2px 10px rgba(0,0,0,0.05), inset 0 1px 0 rgba(255,255,255,0.5)",
          padding: 2,
          marginBottom: 2,
        }}
      >
        <Box sx={{ 
          display: "flex", 
          justifyContent: "space-between", 
          alignItems: "center",
          mb: 2
        }}>
          <Typography variant="h6" sx={{
            fontSize: "1.1rem",
            fontWeight: "bold",
            color: theme === "dark" ? "rgba(255,255,255,0.8)" : "rgba(0,0,0,0.8)",
          }}>
            Video Editing - {hoursTotal} Hours
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <IconButton
              onClick={toggleShowVideoEditingItem}
              disabled={isDebouncing}
              sx={{
                color: theme === "dark" ? "rgba(255,100,100,0.8)" : "rgba(200,50,50,0.8)"
              }}
            >
              <RemoveIcon />
            </IconButton>
            <IconButton
              onClick={addVideoEditingItem}
              disabled={isDebouncing}
              sx={{
                color: theme === "dark" ? "rgba(100,255,100,0.8)" : "rgba(50,150,50,0.8)"
              }}
            >
              <AddIcon />
            </IconButton>
          </Box>
        </Box>

        <Box sx={{ 
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}>
          {videoEditingBreakdown &&
            Array.isArray(videoEditingBreakdown) &&
            videoEditingBreakdown.map((vei, index) => (
              <VideoEditingItemV2
                key={vei.id}
                item={vei}
                items={videoEditingBreakdown}
                setItems={setVideoEditingBreakdown}
                index={index}
                showRemoveVideoEditingItem={showRemoveVideoEditingItem}
                jobData={jobData}
                staffData={staffData}
                updateFS={updateFS}
                findStaff={findStaff}
              />
            ))}
        </Box>
      </Box>
    </motion.div>
  );
};

export default VideoEditingBreakdownV2;